import { Badge, Space, Spin, Tabs } from 'antd'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { LoaderProfilerTab } from './LoaderProfilerTab'
import { ConfigLoaderProfiler } from './profilers/ConfigLoaderProfiler'
import { I18nLoaderProfiler } from './profilers/I18nLoaderProfiler'
import { ResourceLoaderProfiler } from './profilers/ResourceLoaderProfiler'
import { RouteLoaderProfiler } from './profilers/RouteLoaderProfiler'
import { ServiceLoaderProfiler } from './profilers/ServiceLoaderProfiler'

export const DebugProfilerTabs: React.FC = observer(() => {
    const [loading, setLoading] = useState(false)
    const [counts, setCounts] = useState<Record<string, number>>({})

    // Створюємо екземпляри профайлерів-класів
    const routeProfiler = new RouteLoaderProfiler()
    const resourceProfiler = new ResourceLoaderProfiler()
    const configProfiler = new ConfigLoaderProfiler()
    const serviceProfiler = new ServiceLoaderProfiler()

    const loadData = async () => {
        setLoading(true)
        try {
            // Завантажуємо дані з кожного профайлера для отримання counts
            const profilers = [
                { key: 'routes', profiler: routeProfiler },
                { key: 'resources', profiler: resourceProfiler },
                { key: 'i18n', profiler: I18nLoaderProfiler },
                { key: 'config', profiler: configProfiler },
                { key: 'services', profiler: serviceProfiler },
            ]

            const newCounts: Record<string, number> = {}
            
            await Promise.all(
                profilers.map(async ({ key, profiler }) => {
                    try {
                        const data = await profiler.getData()
                        newCounts[key] = data.summary?.count || 0
                    } catch (error) {
                        newCounts[key] = 0
                    }
                })
            )

            setCounts(newCounts)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const tabItems = [
        {
            key: 'routes',
            label: (
                <Space size={8}>
                    <span>Маршрути</span>
                    <Badge 
                        count={counts['routes'] || 0} 
                        showZero={false}
                        style={{ backgroundColor: '#52c41a' }}
                    />
                </Space>
            ),
            children: <LoaderProfilerTab profiler={routeProfiler} />,
        },
        {
            key: 'resources',
            label: (
                <Space size={8}>
                    <span>Ресурси</span>
                    <Badge 
                        count={counts['resources'] || 0} 
                        showZero={false}
                        style={{ backgroundColor: '#52c41a' }}
                    />
                </Space>
            ),
            children: <LoaderProfilerTab profiler={resourceProfiler} />,
        },
        {
            key: 'i18n',
            label: (
                <Space size={8}>
                    <span>Локалізація</span>
                    <Badge 
                        count={counts['i18n'] || 0} 
                        showZero={false}
                        style={{ backgroundColor: '#52c41a' }}
                    />
                </Space>
            ),
            children: <LoaderProfilerTab profiler={I18nLoaderProfiler} />,
        },
        {
            key: 'config',
            label: (
                <Space size={8}>
                    <span>Конфігурація</span>
                    <Badge 
                        count={counts['config'] || 0} 
                        showZero={false}
                        style={{ backgroundColor: '#52c41a' }}
                    />
                </Space>
            ),
            children: <LoaderProfilerTab profiler={configProfiler} />,
        },
        {
            key: 'services',
            label: (
                <Space size={8}>
                    <span>Сервіси</span>
                    <Badge 
                        count={counts['services'] || 0} 
                        showZero={false}
                        style={{ backgroundColor: '#52c41a' }}
                    />
                </Space>
            ),
            children: <LoaderProfilerTab profiler={serviceProfiler} />,
        },
        // {
        //     key: 'rest-requests',
        //     label: (
        //         <Badge count={0} size="small">
        //             <Space>REST Запити</Space>
        //         </Badge>
        //     ),
        //     children: <LoaderProfilerTab profiler={restRequestProfiler} />,
        // },
        // {
        //     key: 'ui-components',
        //     label: (
        //         <Badge count={stats.components.total} size="small">
        //             <Space>UI Компоненти</Space>
        //         </Badge>
        //     ),
        //     children: <UIComponentsProfilerTab />,
        // },
        // {
        //     key: 'logs',
        //     label: (
        //         <Badge count={logStats.errors} size="small">
        //             <Space>Логи</Space>
        //         </Badge>
        //     ),
        //     children: (
        //         <div>
        //             <Alert
        //                 message="Логи системи"
        //                 description="Отображение логов будет добавлено в следующей версии"
        //                 type="info"
        //                 showIcon
        //             />
        //         </div>
        //     ),
        // },
    ]

    return (
        <Spin spinning={loading}>
            <Tabs 
                items={tabItems} 
                size="middle" 
                tabPlacement="top"
                style={{ padding: '8px 0' }}
                tabBarStyle={{ marginBottom: 16 }}
            />
        </Spin>
    )
})
